import { render, staticRenderFns } from "./PatientOverviewBehaviourChange.vue?vue&type=template&id=35db6880&"
import script from "./PatientOverviewBehaviourChange.vue?vue&type=script&lang=js&"
export * from "./PatientOverviewBehaviourChange.vue?vue&type=script&lang=js&"
import style0 from "./PatientOverviewBehaviourChange.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardTitle } from 'vuetify/lib/components/VCard';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VSimpleTable } from 'vuetify/lib/components/VDataTable';
installComponents(component, {VCard,VCardTitle,VIcon,VSimpleTable})
